export function enterFullScreen(element) {
  let isFullscreen = false;

  // Check if fullscreen is supported
  const canFullscreen =
    document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled;

  if (!canFullscreen) {
    console.log('Fullscreen mode is not supported on this device.');
    return isFullscreen;
  }

  // Request fullscreen
  if (element?.requestFullscreen) {
    isFullscreen = true;
    element.requestFullscreen();
  } else if (element?.webkitRequestFullscreen) {
    isFullscreen = true;
    element.webkitRequestFullscreen(); // Safari
  } else if (element?.mozRequestFullScreen) {
    isFullscreen = true;
    element.mozRequestFullScreen(); // Firefox
  } else if (element?.msRequestFullscreen) {
    isFullscreen = true;
    element.msRequestFullscreen(); // IE/Edge
  }

  // Lock screen orientation
  if (screen.orientation && screen.orientation.lock) {
    screen.orientation.lock('landscape').catch(function (error) {
      console.log('Failed to lock orientation:', error);
    });
  } else if (screen?.lockOrientation) {
    screen.lockOrientation('landscape');
  } else if (screen?.mozLockOrientation) {
    screen.mozLockOrientation('landscape');
  } else if (screen?.msLockOrientation) {
    screen.msLockOrientation('landscape');
  } else {
    console.log('Orientation locking not supported on this device.');
  }

  return isFullscreen;
}

export function exitFullscreen() {
  // Check if the document is currently in fullscreen mode
  const isFullscreen =
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement;

  if (!isFullscreen) {
    console.log('Not in fullscreen mode.');
    return;
  }

  // Unlock screen orientation if applicable
  if (screen.orientation && screen.orientation.unlock) {
    screen.orientation.unlock();
  } else if (screen?.unlockOrientation) {
    screen?.unlockOrientation();
  } else if (screen?.mozUnlockOrientation) {
    screen?.mozUnlockOrientation();
  } else if (screen?.msUnlockOrientation) {
    screen?.msUnlockOrientation();
  }

  // Exit fullscreen
  if (document?.exitFullscreen) {
    document
      .exitFullscreen()
      .catch((err) => console.error('Error exiting fullscreen:', err));
  } else if (document?.mozCancelFullScreen) {
    document?.mozCancelFullScreen();
  } else if (document?.webkitExitFullscreen) {
    document?.webkitExitFullscreen();
  } else {
    console.log('Fullscreen exit method not supported.');
  }
}
